import React from 'react';
import { Warning } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../types';
import { getDaysRemainingInGracePeriod } from '../utils/helpers';
import * as routes from '../utils/routes';

interface SubscriptionBannerProps {
	isOwner?: boolean;
	isExpired: boolean;
	isInGracePeriod?: boolean;
}

const SubscriptionBanner: React.FC<SubscriptionBannerProps> = ({ isOwner, isExpired, isInGracePeriod }) => {
	const navigate = useNavigate();
	const subscription = useSelector((state: RootState) => state.auth.subscription);

	const handleRenewClick = () => {
		navigate(routes.SUBSCRIPTION);
	};

	// const isInGracePeriod = subscription && isInGracePeriod(subscription);
	const daysRemaining = subscription ? getDaysRemainingInGracePeriod(subscription) : 0;

	const isVisible = isExpired || isInGracePeriod;

	if (isVisible === false) {
		console.log('Subscription is not expired, not rendering banner', { isOwner, isInGracePeriod, daysRemaining });
		return null; // Don't render the banner if the subscription is not expired
	} else {
		console.log('Subscription is expired, rendering banner', { isOwner, isInGracePeriod, daysRemaining });
	}

	return (
		<div className="w-full">
			<div
				className={`px-4 py-3 rounded-md flex items-center justify-between ${
					isInGracePeriod ? 'bg-yellow-50 border border-yellow-200' : 'bg-blue-50 border border-blue-200'
				}`}
			>
				<div className="flex items-center gap-3">
					<Warning className={isInGracePeriod ? 'text-yellow-600' : 'text-blue-600'} fontSize="small" />
					<div>
						<span className={`text-sm ${isInGracePeriod ? 'text-yellow-700' : 'text-blue-700'}`}>
							{isInGracePeriod ? (
								<>
									Your subscription has expired. You have{' '}
									<span className="font-semibold">
										{daysRemaining} day{daysRemaining !== 1 ? 's' : ''}
									</span>{' '}
									remaining before editing and creating are disabled.
									{!isOwner && ' Please contact the shop owner to renew the subscription.'}
								</>
							) : (
								<>
									You don't have an active subscription. Please subscribe to a plan.
									{!isOwner && ' Please contact the shop owner to subscribe to a plan.'}
								</>
							)}
						</span>
					</div>
				</div>
				{isOwner && (
					<button
						onClick={handleRenewClick}
						className={`px-4 transition-colors text-sm font-medium ${
							isInGracePeriod
								? 'text-yellow-600 hover:text-yellow-700'
								: 'text-blue-600 hover:text-blue-700'
						}`}
					>
						Subscribe
					</button>
				)}
			</div>
		</div>
	);
};

export default SubscriptionBanner;
